module.exports = __webpack_public_path__ + "img/ic_optimism.d1bcd868.png";